/*
 *                        _oo0oo_
 *                       o8888888o
 *                       88" . "88
 *                       (| -_- |)
 *                       0\  =  /0
 *                     ___/`---'\___
 *                   .' \\|     |// '.
 *                  / \\|||  :  |||// \
 *                 / _||||| -:- |||||- \
 *                |   | \\\  - /// |   |
 *                | \_|  ''\---/''  |_/ |
 *                \  .-\__  '-'  ___/-. /
 *              ___'. .'  /--.--\  `. .'___
 *           ."" '<  `.___\_<|>_/___.' >' "".
 *          | | :  `- \`.;`\ _ /`;.`/ - ` : | |
 *          \  \ `_.   \_ __\ /__ _/   .-` /  /
 *      =====`-.____`.___ \_____/___.-`___.-'=====
 *                        `=---='
 *
 *
 *      ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 *
 *            佛祖保佑     永不宕机     永无BUG
 *
 * @Author: DY
 * @Date: 2026-07-01 22:46:51
 * @LastEditors: DY
 * @LastEditTime: 2026-07-01 23:01:55
 * @FilePath: \ShiMoMobile\src\assets\mixin\mixin_outboundTypeSelect.js
 * @Description: 物资领用、原材料领用-申请单出库类型选择
 */


export const mixin_outboundTypeSelect = {
    data() {
        return {
            material_category: 0, // 物资领用申请单出库类型为1，原材料领用申请单出库类型为0
            showOutstockType: false,
            outstockTypeList: [],
        };
    },
    async created() {
        const res = await this.getOutstockTypeList();
        this.outstockTypeList = res.map(item => ({
            name: item.OutstockTypeName,
            code: item.OutstockTypeCode,
        }));
    },
    methods: {
        // 选择出库类型
        selectOutstockType() {
            if (this.isDisabled) { return; }
            this.showOutstockType = true;
        },
        selectOutstockTypeConfirm(val) {
            this.formData.OutstockTypeCode = val.code;
            this.formData.OutstockTypeName = val.name;
            this.showOutstockType = false;
        },
        getOutstockTypeList() {
            return this.$axios.$get(`/interfaceApi/procurement/configoutstocktype/getlist?material_category=${this.material_category}`);
        },
    },
};
